import axios from 'axios';
import { CONFIG } from '@/config/Config';
import { addSessionId } from '@/core/utils/httpHeaders';

export interface PanelCreditOption {
  name?: string;
  productName?: string;
  quotationItemId?: string;
  expirationDate?: string | number;
}

export interface NormalizedPanelCreditOption {
  name: string;
  expirationDate: string;
  quotationItemId?: string;
}

export interface PanelCreditsResponse {
  available?: {
    storage?: PanelCreditOption[];
    sla?: PanelCreditOption[];
  };
  storageOptions?: PanelCreditOption[];
  slaOptions?: PanelCreditOption[];
}

class PanelCreditsService {
  async getPanelCredits(accountId: string, userGroup: string): Promise<PanelCreditsResponse> {
    const url = `${CONFIG.getGatewayUrl()}credits-system/${CONFIG.getVersion()}/panel-credits`;
    const response = await axios.get<PanelCreditsResponse>(url, {
      params: { accountId, userGroup },
      headers: addSessionId({ 'Content-Type': 'application/json' }),
      timeout: CONFIG.AUTH.TIMEOUT,
    });

    return response.data;
  }
}

export default new PanelCreditsService();